import { render, staticRenderFns } from "./TutorDashboardIndex.vue?vue&type=template&id=1f0a655e"
import script from "./TutorDashboardIndex.js?vue&type=script&lang=js&external"
export * from "./TutorDashboardIndex.js?vue&type=script&lang=js&external"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports